/* eslint-disable no-console */
import { uspsAddressValidate } from "@gemeco/Services/CustomerService";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import validateAddress, {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

// modules\client-framework\src\Store\CommonHandlers\ValidateAddress.ts
type HandlerType = Parameters<typeof ExecuteOnSuccessCallback>[0];

export type GemecoValidateAddressHandlerType = Parameters<typeof validateAddress>[0] & {
    isOneTimeAddress?: boolean;
    byPassAddressValidation?: boolean;
};

addToChainBefore(chain, ExecuteOnSuccessCallback, UspsApiValidation);

async function UspsApiValidation(props: HandlerType) {
    const isOneTime = (props.parameter as GemecoValidateAddressHandlerType)?.isOneTimeAddress ?? false;
    const byPassAddressValidation =
        (props.parameter as GemecoValidateAddressHandlerType)?.byPassAddressValidation ?? false;
    if (isOneTime) {
        const hasCurrentErrors =
            props?.addressErrors && props.addressErrors != null && Object.keys(props.addressErrors).length > 0;
        const websiteSettings = getSettingsCollection(props.getState()).websiteSettings;
        const isUspsCountry =
            (websiteSettings?.uspsAddressValidationCountryCodes?.length ?? 0) > 0 &&
            websiteSettings?.uspsAddressValidationCountryCodes?.includes(
                props.parameter.address.country?.abbreviation ?? "",
            );
        if (!hasCurrentErrors && isUspsCountry) {
            const stateCode = props.parameter.address?.state?.abbreviation;
            const uspsApiValidationResult = await uspsAddressValidate(
                props.parameter.address.address1,
                props.parameter.address.address2,
                props.parameter.address.city,
                stateCode || "",
                props.parameter.address.postalCode,
            );
            if (byPassAddressValidation === false && !uspsApiValidationResult.isValid) {
                props.addressErrors.uspsValidationError = uspsApiValidationResult.validationMessages.join(", ");
            }
        }
    }
}